import { defineMessages } from 'react-intl'

export default defineMessages({
  networkError: {
    id: 'utils.callAPI.networkError',
    defaultMessage: 'Network error, please try again later！',
    description: '网络错误',
  },
  systemError: {
    id: 'utils.callAPI.system',
    defaultMessage: 'System error, please try it later!',
    description: '系统错误',
  },
  openUriToastInfo: {
    id: 'utils.index.openUriToastInfo',
    defaultMessage: 'Only support Android and iOS system!',
    description: 'open Uri Toast Info',
  },
})
